export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "betfirst-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "betfirst-themeWrapLive" */'./LiveThemeImporter'),
  },
};
